import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/docs_img_02.png")